export default "__VITE_ASSET__DnuoXHZs__"